import type {CardApiModel} from '../../../api/payment';
import type {AsyncStrategy} from '../utils';

import {cardStore} from '../../../api/payment';
import {alert} from '../../../components/alert';
import {isIamCoach} from '../../../utils/entity/isIamCoach';
import {logger} from '../../../utils/logger';
import {COMMAND} from '../utils';

type Config = {
  entity: CardApiModel;
};

export {cardDelete};

const strategy: AsyncStrategy<Config> = async (roles, config) => {
  if (isIamCoach()) {
    return roles.coach(config);
  } else {
    return roles.client(config);
  }
};

async function cardDelete(config: Config) {
  return strategy({client: deleteCard, coach: deleteCard}, config);
}

cardDelete.asClient = deleteCard;
cardDelete.asCoach = deleteCard;

async function deleteCard({entity}: Config) {
  const isConfirmed = await alert.confirm();

  if (!isConfirmed) {
    return COMMAND.CANCEL;
  }

  try {
    await cardStore.delete(entity);
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
